module.exports = __webpack_public_path__ + "img/sharp_bg1.1b50a8dc.png";